/**
 * EventOrganiser — who is putting the event on.
 */

import React from 'react';

export default function EventOrganiser({ name, city, state, websiteUrl }) {
  return (
    <section className="evb-sec">
      <h2 className="evb-h">Organiser</h2>
      <div className="evb-org">
        <div>
          <p className="evb-org__n">{name}</p>
          <p className="evb-org__m">{city} &nbsp;·&nbsp; {state}</p>
        </div>
        {/* Only offer the link when the organiser gave a usable URL — a
            "Visit website" that goes nowhere is a dead end. */}
        {websiteUrl && (
          <a className="evb-link" href={websiteUrl}>Visit website →</a>
        )}
      </div>
    </section>
  );
}
